import { MDCFloatingLabel } from '@material/floating-label';
import { MDCLineRipple } from '@material/line-ripple';
import { MDCNotchedOutline } from '@material/notched-outline';

// @material/select/constants.numbers.LABEL_SCALE
const LABEL_SCALE = 0.75;

export default {
  properties: {
    active: {
      type: Boolean,
      default: false,
      observer() {
        this.activeChanged();
      },
    },
    selected: {
      type: Boolean,
      default: false,
      observer() {
        if (!this.active) this.notchOutline(this.selected);
        this.selectedChanged();
      },
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.selectRoot = this.querySelector('.mdc-select');
    this.resultWrapper = this.querySelector('.mdc-select__selected-text');

    this.initMDCComponents();

    this.listenTo(this.resultWrapper, {
      focusin: this.handleFocusin.bind(this),
      focusout: this.handleFocusout.bind(this),
    });

    if (this.clearable) {
      this.listenTo(this.querySelector('.link-clear'), {
        mousedown: this.handleClearLinkClick.bind(this),
      });
    }
  },

  layout() {
    this.notchOutline(this.selected);
  },

  disconnected() {
    this.active = false;

    this.stopListening();

    if (this.mdcFloatingLabel) this.mdcFloatingLabel.destroy();
    if (this.mdcLineRipple) this.mdcLineRipple.destroy();
    if (this.mdcNotchedOutline) this.mdcNotchedOutline.destroy();
  },

  initMDCComponents() {
    const label = this.querySelector('.mdc-floating-label');
    if (label) this.mdcFloatingLabel = new MDCFloatingLabel(label);

    const lineRipple = this.querySelector('.mdc-line-ripple');
    if (lineRipple) this.mdcLineRipple = new MDCLineRipple(lineRipple);

    const notchedOutline = this.querySelector('.mdc-notched-outline');
    if (notchedOutline) this.mdcNotchedOutline = new MDCNotchedOutline(notchedOutline);
  },

  handleFocusin() {
    if (!this.active) {
      this.active = true;
      this.namespacedTrigger('active');
    }
  },

  handleFocusout(event) {
    if (!event.relatedTarget || !this.resultWrapper.contains(event.relatedTarget)) {
      this.namespacedTrigger('blur', {
        detail: { originalEvent: event },
      });
    }
  },

  notchOutline(openNotch) {
    if (!this.mdcFloatingLabel || !this.mdcNotchedOutline) return;

    if (this.mdcFloatingLabel) this.mdcFloatingLabel.float(openNotch);

    if (openNotch) {
      this.mdcNotchedOutline.notch(this.mdcFloatingLabel.getWidth() * LABEL_SCALE);
    } else {
      this.mdcNotchedOutline.closeNotch();
    }
  },

  activeSelectRoot() {
    this.selectRoot.classList.add('mdc-select--focused');

    this.notchOutline(true);
    if (this.mdcLineRipple) this.mdcLineRipple.activate();
  },

  deactiveSelectRoot() {
    this.selectRoot.classList.remove('mdc-select--focused');

    this.notchOutline(this.selected);
    if (this.mdcLineRipple) this.mdcLineRipple.deactivate();
  },

  handleClearLinkClick() {},

  activeChanged() {},

  selectedChanged() {},
};
